import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './FooterHeading.module.css';
//#region [Props]
type FooterHeadingProps = {
  children: React.ReactNode;
  className?: string;
};
//#endregion

//#region [Component]
export default function FooterHeading(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.SFooterHeading, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
//#endregion